// Effect Managers
import { call, race, select, take } from 'redux-saga/effects'

// Controller
import gridCtrl from 'hfty-ctrl-grid'
import jobsCtrl from 'fc-ctrl-sampling-jobs'

// Selectors
import gridGeoJSON$ from '../selectors/gridGeoJson'
import { operation$ } from 'hfty-soil-jobs-dom'

// Operators
import soilJobsOperator from 'fc-operator-sampling-jobs'


export default function *handleMapOperations (): Generator<*, *, *> {
  const { cancel } = yield race({
    submit: take([soilJobsOperator.actionTypes.submitOperations(),
      soilJobsOperator.actionTypes.submitOperation()]),
    cancel: take([soilJobsOperator.actionTypes.cancelOperation(),
      soilJobsOperator.actionTypes.cancelOperations()]),
  })
  if (cancel) {
    return
  }

  while (true) {
    let gridOperation = yield select(operation$)

    const { submit, cancel, created, updated } = yield race({
      submit: take([soilJobsOperator.actionTypes.submitOperations(),
        soilJobsOperator.actionTypes.submitOperation()]),
      cancel: take([soilJobsOperator.actionTypes.cancelOperation(),
        soilJobsOperator.actionTypes.cancelOperations()]),
      created: take(jobsCtrl.actionTypes.created()),
      updated: take(jobsCtrl.actionTypes.updated()),
    })
    // Cancel came up after a submit operation
    //  Failed job creation, failed something
    if (cancel) {
      return
    } else if (submit) {
      // Might need to do editting after a failed submit
      // First submit failed validation or something, refresh w/new gridData

      continue
    } else if (created) {
      const jobId = created.payload.model.id
      const gridData$ = gridGeoJSON$(gridOperation)
      const geoJSON = yield select(gridData$)
      if (geoJSON) {
        const jsonGridData = JSON.stringify(geoJSON)
        yield call(gridCtrl.create, {
          model: {
            grid: jsonGridData,
            job: jobId,
          }})
      }
      return
    } else if (updated) {
      const job = gridOperation.model.job
      const gridData$ = gridGeoJSON$(gridOperation)
      const geoJSON = yield select(gridData$)

      if (geoJSON) {
        const jsonGridData = JSON.stringify(geoJSON)

        const operation = job.grid_id ? gridCtrl.update : gridCtrl.create

        yield call(operation,
          {
            model: {
              grid: jsonGridData,
              job: job.id,
              id: gridOperation.model.job.grid_id,
            },
          })
      }

      return
    }
  }
}
